import { Paper } from '@mui/material';

import { BackupOutlinedIcon, Typography } from '@occc/ui-design-system';

export const RetailerNetworkDataPlaceholder = ({
  title,
  description,
}: {
  title: string;
  description: string;
}) => {
  return (
    <Paper
      elevation={2}
      sx={{
        minHeight: '50vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 1,
        borderRadius: 1,
        p: 3,
      }}
    >
      <BackupOutlinedIcon sx={{ fontSize: 48, color: 'text.disabled' }} />
      <Typography variant='h5' align='center' sx={{ whiteSpace: 'pre-line' }}>
        {title}
      </Typography>
      <Typography
        variant='body1'
        align='center'
        color='text.secondary'
        sx={{ whiteSpace: 'pre-line' }}
      >
        {description}
      </Typography>
    </Paper>
  );
};
